import {
  AgentTaskSchema,
  AgentTaskStatus,
} from "@redotech/redo-model/agent-tasks";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const updateTaskStatusOutput_ = z.object({ task: AgentTaskSchema });
export const UpdateTaskStatusOutput: z.ZodType<UpdateTaskStatusOutput> =
  updateTaskStatusOutput_;
export interface UpdateTaskStatusOutput
  extends z.infer<typeof updateTaskStatusOutput_> {}

export const updateTaskStatus = {
  name: "updateTaskStatus" as const,
  input: z.object({
    taskId: z.string(),
    status: createEnum(AgentTaskStatus, { enumName: "agent_task_status" }),
  }),
  output: updateTaskStatusOutput_,
};
